import axios from "axios";
import {URL_API} from "@/constants/constants";

axios.defaults.baseURL = URL_API;
axios.defaults.headers.common["e-token"] = localStorage.getItem("etoken");
//axios.defaults.headers.common["Access-Control-Allow-Origin"] = '*';